export default "__VITE_ASSET__29e38ac5__"